export const OPEN_SHARE_BOX = 'OPEN_SHARE_BOX'
export const CLOSE_SHARE_BOX = 'CLOSE_SHARE_BOX'
